import { render, staticRenderFns } from "./IpsFilePicker.vue?vue&type=template&id=65658e5a&scoped=true"
import script from "./IpsFilePicker.vue?vue&type=script&lang=js"
export * from "./IpsFilePicker.vue?vue&type=script&lang=js"
import style0 from "./IpsFilePicker.vue?vue&type=style&index=0&id=65658e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65658e5a",
  null
  
)

export default component.exports